import {
  CLEAR_DEAL_HUNTER_SESSIONS,
  RADAR_POLL_ATTEMPTED,
  RADAR_POLL_COMPLETED,
  RADAR_RESPONSE_RECEIVED,
  RADAR_SESSION_STARTED,
  REQUEST_MONTH_DATA,
} from '../helpers/constants/actionsConstants';

import type {
  DealHunterAction,
  DealHunterState,
} from '../selectors/dealHunterTypes';

const initialState: DealHunterState = {
  sessions: {},
};

export const reducer = (
  state: DealHunterState = initialState,
  action: DealHunterAction,
): DealHunterState => {
  switch (action.type) {
    case RADAR_SESSION_STARTED: {
      const { tripDuration } = action.payload;
      return {
        ...state,
        sessions: {
          ...state.sessions,
          [tripDuration]: {
            status: 'incomplete',
            pollCount: 0,
          },
        },
      };
    }

    case RADAR_POLL_ATTEMPTED: {
      const { tripDuration } = action.payload;
      const session = state.sessions[tripDuration];
      if (!session) return state;

      return {
        ...state,
        sessions: {
          ...state.sessions,
          [tripDuration]: {
            ...session,
            pollCount: (session.pollCount ?? 0) + 1,
          },
        },
      };
    }

    case RADAR_RESPONSE_RECEIVED: {
      const {
        cheapestDirectItinerary,
        cheapestItinerary,
        pollingSessionToken,
        tripDuration,
      } = action.payload;
      const session = state.sessions[tripDuration];
      if (!session) return state;

      return {
        ...state,
        sessions: {
          ...state.sessions,
          [tripDuration]: {
            ...session,
            pollingSessionToken:
              pollingSessionToken || session.pollingSessionToken,
            cheapestItinerary: cheapestItinerary || session.cheapestItinerary,
            cheapestDirectItinerary:
              cheapestDirectItinerary || session.cheapestDirectItinerary,
          },
        },
      };
    }

    case RADAR_POLL_COMPLETED: {
      const { tripDuration } = action.payload;
      const session = state.sessions[tripDuration];
      if (!session) return state;

      return {
        ...state,
        sessions: {
          ...state.sessions,
          [tripDuration]: {
            ...session,
            status: 'complete',
          },
        },
      };
    }

    case CLEAR_DEAL_HUNTER_SESSIONS:
    case `${REQUEST_MONTH_DATA}_STARTED`: {
      return initialState;
    }

    default:
      return state;
  }
};

export default reducer;
